import { useNavigate, useParams } from 'react-router-dom';
import { useMutation, useQuery } from 'react-query';
import React from 'react';
import { useFormik } from 'formik';
import * as yup from 'yup';
import api from '../../../../components/api';
import { yupErrorMsg } from '../../../../components/atoms/const';

function useUsersAddUser() {
  /*
  *
  *
  *
  *
  *
  *
  *
  */

  /*
  * Get Initial Data
  * 1. param from url format : user-management/detail/active/:userId
  * 2. Get Current Active user by params userId
  * 3. Get Role List for Form value
  */
  // 1. Get userId from url
  const { userId } = useParams();

  // 2. Get Active User
  const { data: userRes } = useQuery(
    ['getByType', 'user', 0],
    () => api.user.getAllByType(0),
  );
  // 2.1. Get Current Active user by params userId
  const userById = React.useMemo(() => {
    const listUser = userRes?.data.data;
    if (listUser && userId) {
      return listUser.find((user) => user.id.toString() === userId.toString());
    }
    return undefined;
  }, [userRes, userId]);

  // 3. Get Role list
  const { data: roleRes, isLoading: roleLoading } = useQuery(
    ['getAllRoles', 'user'],
    () => api.user.getAllRoles(),
  );
  const roleList:{value:number, label:string}[] = React.useMemo(() => {
    const resData = roleRes?.data.data;
    if (resData) {
      return resData.map((role) => ({
        value: role.id,
        label: role.name,
      }));
    }
    return [];
  }, [roleRes]);

  // The display-users response does not include a user's role. Resolve it from
  // the existing role-filtered endpoint when editing so the select is populated.
  const { data: currentRoleId, isLoading: currentRoleLoading } = useQuery(
    ['getRoleByUserId', 'user', userId, roleList.map((role) => role.value).join(',')],
    async () => {
      const usersByRole = await Promise.all(
        roleList.map((role) => api.user.getAllByRole(role.value)),
      );
      const roleIndex = usersByRole.findIndex((response) => (
        response.data.data?.some((user) => user.id.toString() === userId)
      ));
      return roleIndex >= 0 ? roleList[roleIndex].value : undefined;
    },
    {
      enabled: !!userId && roleList.length > 0,
    },
  );

  /*
  *
  *
  *
  *
  *
  *
  *
  */

  /*
  * Navigate Handler
  */
  const navigate = useNavigate();
  // Navigate to user management landing page
  const onNavigateCancel = () => navigate('/user-management');
  // Navigate After edit to Detail User
  const onNavigateDetailUser = () => navigate(`/user-management/detail/active/${userId}`);

  /*
  *
  *
  *
  *
  *
  *
  *
  */

  /*
  * Handle for add or update User
  */
  // 1. Add New User
  const { isLoading: addUserLoad, mutate: addNewUser } = useMutation(api.user.add, {
    onMutate: (x) => console.log('onMutate', x),
    onSuccess: (res) => {
      console.log(res);
      alert('success');
      onNavigateCancel();
    },
    onError: (err) => {
      console.log('err', err);
      alert('error');
    },
  });
  // 2. Edit User
  const { isLoading: updateUserLoad, mutate: updateUser } = useMutation(api.user.update, {
    onMutate: (x) => console.log('onMutate', x),
    onSuccess: (res) => {
      console.log(res);
      alert('success');
      onNavigateDetailUser();
    },
    onError: (err) => {
      console.log('err', err);
      alert('error');
    },
  });

  // Form validation
  const yupSchema = yup.object({
    username: yup.string().required(yupErrorMsg.USERNAME_EMPTY),
    phoneNumber: yup.string().required(yupErrorMsg.PHONE_NUMBER_EMPTY),
    firstname: yup.string().required(yupErrorMsg.FIRST_NAME_EMPTY),
    lastname: yup.string().required(yupErrorMsg.LAST_NAME_EMPTY),
    position: yup.string().required(yupErrorMsg.POSITION_EMPTY),
    role: yup.string().required(yupErrorMsg.ROLE_EMPTY),
  });
  // Form handler with formik
  const formik = useFormik({
    initialValues: {
      username: '',
      phoneNumber: '',
      firstname: '',
      lastname: '',
      role: '',
      position: '',
      password: 'password123',
    },
    validationSchema: yupSchema,
    onSubmit: ((values) => {
      if (!userId) {
        addNewUser(values);
      } else {
        updateUser({
          ...values,
          id: userId!,
        });
      }
    }),
  });

  // Initial data when on Edit Mode
  React.useEffect(() => {
    if (userById && userId) {
      formik.setFieldValue('username', userById.username ?? '');
      formik.setFieldValue('phoneNumber', userById.phoneNumber ?? '');
      formik.setFieldValue('firstname', userById.firstname ?? '');
      formik.setFieldValue('lastname', userById.lastname ?? '');
      formik.setFieldValue('position', userById.position ?? '');
      formik.setFieldValue('userId', userById.id ?? '');
      if (currentRoleId !== undefined) {
        formik.setFieldValue('role', currentRoleId.toString());
      }
    }
  }, [userById, currentRoleId]);

  return {
    userId,
    userById,
    formik,
    roleList,
    roleLoading: roleLoading || currentRoleLoading,
    onNavigateCancel,
    addUserLoad,
    updateUserLoad,
  };
}
export default useUsersAddUser;
